import CurrencyTextUpdater from "../currency_text_updater";

/**
*  Optional Services support for /users/contracts/invoice_program_offers_controller.js
**/
export default class OptionalServices {
  constructor(controller) {
    this.controller = controller;
    this.updater = new CurrencyTextUpdater();
  }

  calculateOptionalServiceAmounts() {
    this.controller.repaymentAmountTargets.map((repaymentAmountTarget) => {
      const { benefitsPlusAmount, ldwAmount, repaymentAmount } =
        repaymentAmountTarget.dataset;
      const { isBenefitsPlusCheckboxChecked, isLdwCheckboxChecked } =
        this.invoicesController;

      let totalRepaymentAmount = parseFloat(repaymentAmount);

      if (isLdwCheckboxChecked) totalRepaymentAmount += parseFloat(ldwAmount);

      if (isBenefitsPlusCheckboxChecked)
        totalRepaymentAmount += parseFloat(benefitsPlusAmount);

      this.updater.update(repaymentAmountTarget, totalRepaymentAmount);
    });

    this.populateOptionalServicesToggleAmounts();
    this.invoicesController.enablePrepaidRentButton();
  }

  populateOptionalServicesToggleAmounts() {
    if (!this.controller.hasPaymentOptionBoxTarget) return;

    const {
      isLdwCheckboxChecked,
      isBenefitsPlusCheckboxChecked,
      optionalServicesLdwFeeAmountTarget,
      optionalServicesBenefitsPlusFeeAmountTarget,
    } = this.invoicesController;

    if (this.controller.selectedTerm === undefined) {
      optionalServicesLdwFeeAmountTarget.textContent = "$ --";
      optionalServicesBenefitsPlusFeeAmountTarget.textContent = "$ --";
      return;
    }

    const { benefitsPlusAmount, ldwAmount } =
      this.controller.selectedTerm.querySelector(".offer-title > span").dataset;

    if (isBenefitsPlusCheckboxChecked) {
      this.updater.update(
        optionalServicesBenefitsPlusFeeAmountTarget,
        benefitsPlusAmount
      );
    } else {
      optionalServicesBenefitsPlusFeeAmountTarget.textContent = "Opted out";
    }

    if (isLdwCheckboxChecked) {
      this.updater.update(optionalServicesLdwFeeAmountTarget, ldwAmount);
    } else {
      optionalServicesLdwFeeAmountTarget.textContent = "Opted out";
    }
  }

  /**
   * Returns InvoicesController reference
   * @return {Object} InvoicesController reference.
   */
  get invoicesController() {
    return this.controller.application.controllers.find((controller) => {
      return controller.identifier.toString() == "users--contracts--invoices";
    });
  }
}
